import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../data/site";
import { PRODUCTS } from "../data/products";
import { useLang } from "../i18n";

const EMPTY = { name: "", company: "", phone: "", email: "", product: "", quantity: "", message: "" };

export const QuoteForm = ({ defaultProduct = "" }) => {
  const { t } = useLang();
  const [form, setForm] = useState({ ...EMPTY, product: defaultProduct });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (defaultProduct) setForm((f) => ({ ...f, product: defaultProduct }));
  }, [defaultProduct]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/quotes`, {
        ...form,
        company: form.company || null,
        quantity: form.quantity || null,
        message: form.message || null,
      });
      toast.success(t("form.success"));
      const waLines = [
        "New Quote Enquiry — Sana Steel Industries",
        `Name: ${form.name}`,
        form.company ? `Company: ${form.company}` : null,
        `Phone: ${form.phone}`,
        `Email: ${form.email}`,
        `Product: ${form.product}`,
        form.quantity ? `Quantity: ${form.quantity}` : null,
        form.message ? `Message: ${form.message}` : null,
      ].filter(Boolean).join("\n");
      window.open(`https://wa.me/917975290977?text=${encodeURIComponent(waLines)}`, "_blank");
      setForm({ ...EMPTY });
    } catch (err) {
      toast.error(t("form.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-7" data-testid="quote-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
        <div>
          <label htmlFor="qf-name" className="field-label">{t("form.name")} *</label>
          <input id="qf-name" data-testid="quote-name-input" required value={form.name} onChange={set("name")}
                 placeholder={t("form.ph.name")} className="field" />
        </div>
        <div>
          <label htmlFor="qf-company" className="field-label">{t("form.company")}</label>
          <input id="qf-company" data-testid="quote-company-input" value={form.company} onChange={set("company")}
                 placeholder={t("form.ph.company")} className="field" />
        </div>
        <div>
          <label htmlFor="qf-phone" className="field-label">{t("form.phone")} *</label>
          <input id="qf-phone" data-testid="quote-phone-input" required type="tel" value={form.phone} onChange={set("phone")}
                 placeholder="+91 …" className="field" />
        </div>
        <div>
          <label htmlFor="qf-email" className="field-label">{t("form.email")} *</label>
          <input id="qf-email" data-testid="quote-email-input" required type="email" value={form.email} onChange={set("email")}
                 placeholder="you@company.com" className="field" />
        </div>
        <div>
          <label htmlFor="qf-product" className="field-label">{t("form.product")} *</label>
          <select id="qf-product" data-testid="quote-product-select" required value={form.product} onChange={set("product")}
                  className="field bg-white">
            <option value="" disabled>{t("form.selectProduct")}</option>
            {PRODUCTS.map((p) => (
              <option key={p.slug} value={p.name}>{p.name}</option>
            ))}
            <option value="General Enquiry">{t("form.general")}</option>
          </select>
        </div>
        <div>
          <label htmlFor="qf-quantity" className="field-label">{t("form.quantity")}</label>
          <input id="qf-quantity" data-testid="quote-quantity-input" value={form.quantity} onChange={set("quantity")}
                 placeholder={t("form.ph.quantity")} className="field" />
        </div>
      </div>
      <div>
        <label htmlFor="qf-message" className="field-label">{t("form.message")}</label>
        <textarea id="qf-message" data-testid="quote-message-input" rows={4} value={form.message} onChange={set("message")}
                  placeholder={t("form.ph.message")} className="field resize-none" />
      </div>
      <button type="submit" disabled={loading} data-testid="quote-submit-button" className="btn-primary disabled:opacity-60 disabled:pointer-events-none">
        {loading ? t("form.sending") : t("form.submit")}
      </button>
    </form>
  );
};
